import React from "react";
import HelpUsImproveComponent from "../../../components/helpUsImproveComponent/HelpUsImproveComponent";

const HelpUsPage = () => {
  return <HelpUsImproveComponent />;
};

export default HelpUsPage;
